export const STATE_NAMES = {
  AL: 'Alabama',
  AK: 'Alaska',
  AZ: 'Arizona',
  AR: 'Arkansas',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DC: 'District of Columbia',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  IA: 'Iowa',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  ME: 'Maine',
  MD: 'Maryland',
  MA: 'Massachusetts',
  MI: 'Michigan',
  MN: 'Minnesota',
  MS: 'Mississippi',
  MO: 'Missouri',
  MT: 'Montana',
  NE: 'Nebraska',
  NV: 'Nevada',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NY: 'New York',
  NC: 'North Carolina',
  ND: 'North Dakota',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VT: 'Vermont',
  VA: 'Virginia',
  WA: 'Washington',
  WV: 'West Virginia',
  WI: 'Wisconsin',
  WY: 'Wyoming',
};

export const STATE_CODES = Object.keys(STATE_NAMES);

export const HELP_TOPICS = [
  { title: 'How to choose pre-licensing courses', path: '/courses?type=PE' },
  { title: 'How to renew CE requirements', path: '/courses?type=CE' },
  { title: 'Understanding state-specific licensing rules', path: '/state-requirements' },
  { title: 'How pricing bundles work', path: '/pricing' },
  { title: 'Checkout and payment support', path: '/checkout' },
  { title: 'Certificate access and completion status', path: '/dashboard' },
];

export const ROUTE_LABELS = {
  '/home': 'Home',
  '/dashboard': 'Dashboard',
  '/instructor/dashboard': 'Instructor Dashboard',
  '/instructor/students': 'Students',
  '/courses': 'Courses',
  '/state-requirements': 'State Requirements',
  '/pricing': 'Pricing',
  '/checkout': 'Checkout',
  '/resources': 'Resources',
};
